import { registerGuideTarget } from '@/components/engine/guide/registry'
import { guideState } from '@/components/engine/guide/state'

// Registrations belong to the Vue instance, never to a module ID globally.
export default {
  computed: {
    guideRunning() { return guideState.running }
  },
  mounted() {
    this._guideTargetCleanups = new Map()
    this.syncGuideTargets()
  },
  updated() { this.syncGuideTargets() },
  beforeDestroy() {
    if (this._guideTargetCleanups) this._guideTargetCleanups.forEach(remove => remove())
  },
  methods: {
    guideReady() {
      return !this._isDestroyed && !this._isBeingDestroyed && this.AllowedDisplay !== false && !this.loading &&
        (typeof this.show !== 'boolean' || this.show)
    },
    guideContext() {
      return { pageId: this.page, modalKey: this.modalKey, moduleInstance: this._uid }
    },
    guideTarget(key, element, operations = {}, label = key) {
      return { key, element, operations, label, ready: () => this.guideReady(), context: this.guideContext() }
    },
    syncGuideTargets() {
      if (!this._guideTargetCleanups || !this.$el || !this.$el.setAttribute) return
      const key = `module:${this.idmodule}`
      this.$el.setAttribute('data-guide-target', key)
      this.$el.setAttribute('data-guide-module-instance', this._uid)
      const definitions = [this.guideTarget(key, () => this.$el)]
      if (this.guideModuleTargets) definitions.push(...this.guideModuleTargets())
      const nextKeys = new Set(definitions.map(item => item.key))
      this._guideTargetCleanups.forEach((remove, oldKey) => {
        if (!nextKeys.has(oldKey)) { remove(); this._guideTargetCleanups.delete(oldKey) }
      })
      definitions.forEach(definition => {
        const element = definition.element()
        if (element && element.setAttribute && element.getAttribute('data-guide-target') !== definition.key) element.setAttribute('data-guide-target', definition.key)
        // Rebind dynamic rows to their current data after sorting or filtering.
        const remove = this._guideTargetCleanups.get(definition.key)
        if (remove) remove()
        this._guideTargetCleanups.set(definition.key, registerGuideTarget(definition.key, definition))
      })
    }
  }
}
